import React from 'react'
import Typography from '@material-ui/core/Typography'
import Generic from './Generic'

import {
  getUrl,
} from 'utils/storage'

const SCHEMA = [{
  id: 'meta.email_notifications',
  title: 'Email Notifications',
  helperText: 'Add a list of email addresses that will receive updates when bookings are made',
  component: 'list',
  list_window_size: 'sm',
  list_schema: [{
    id: 'email',
    title: 'Email',
    helperText: 'The email address that will receive updates',
    validate: {
      type: 'string',
      methods: [
        ['required', 'The email is required'],
        ['email', 'Must be a valid email address'],
      ]
    }
  }],
  list_table: [{
    name: 'email',
    title: 'Email',
  }]
}, {
  id: 'meta.email_attachments',
  title: 'Email Attachments',
  helperText: 'Add a list of files that will be attached to customer emails',
  component: 'list',
  list_window_size: 'md',
  list_schema: [{
    id: 'file',
    title: 'File',
    helperText: 'Upload a file',
    component: 'image',
    path: 'email_attachments',
    validate: {
      type: 'object',
      methods: [
        ['required', 'The file is required'],
      ]
    }
  }],
  list_table: [{
    name: 'file',
    title: 'File',
  }],
  list_table_map: (data) => {
    return Object.assign({}, data, {
      file: (
        <Typography variant="caption">
          <a href={ getUrl(data.file.filepath) } target="_blank">{ data.file.filename }</a>
        </Typography>
      )
    })
  }
}]

const BookingFormCommunication = ({

}) => {
  return (
    <Generic
      title="Communication"
      schema={ SCHEMA }
    />
  )
}

export default BookingFormCommunication